import { Component, OnInit, Signal, computed } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AppLayoutService } from '../../../infrastructure/services/layout.service';

import { LoadAnalyticsModules } from '@core/infrastructure/state/core-commands.actions';
import { getLanguageisRTL } from '@core/infrastructure/state/core.selectors';
import { CategoriesSelectors } from '@features/category';
import { removeCategoriesHidden } from '@features/category/application/services/category.utils';
import { routerPublicQueries } from '@frontend/libs/duttirouter';
import { LoadPagesAndHomesMarketLanguages } from '@shared/market/store';

@Component({
    selector: 'default-layout',
    templateUrl: './default-layout.component.html',
})
export class DefaultLayoutComponent implements OnInit {
    public readonly isWebApp: boolean = this.appLayoutService.isWebapp;

    public readonly slugFooter: string = 'footer-comfy';

    public menuData$ = combineLatest([
        this.store.select(CategoriesSelectors.getMenuCategories)
            .pipe(
                filter((menuCategories) => menuCategories && menuCategories.length !== 0),
                map(menuCategories => removeCategoriesHidden(menuCategories))
            ),
        this.store.select(getLanguageisRTL).pipe(map(isRTL => isRTL ? 'rtl' : 'ltr')),
    ]).pipe(
        map(([categories, direction]) => ({ categories, direction }))
    );

    public readonly hideFooter$$: Signal<boolean> = computed(() => {
        const data = this.store.selectSignal(routerPublicQueries.getDataFromRouter)();
        return !!(data?.footer?.disabled || this.isWebApp);
    });

    constructor(
        private readonly appLayoutService: AppLayoutService,
        private readonly store: Store,
    ) { }

    public ngOnInit() {
        this.loadAnalytics();
        this.store.dispatch(LoadPagesAndHomesMarketLanguages());
    }

    private loadAnalytics() {
        this.store.dispatch(LoadAnalyticsModules());
    }
}
